export const constants = {

  GET_USUARIOS_REQUEST: 'GET_USUARIOS_REQUEST',
  GET_USUARIOS_REQUEST_SUCCESS: 'GET_USUARIOS_SUCCESS',
  GET_USUARIOS_REQUEST_FAILURE: 'GET_USUARIOS_FAILURE',

  GET_PRESCRIPTORES_REQUEST: 'GET_PRESCRIPTORES_REQUEST',
  GET_PRESCRIPTORES_REQUEST_SUCCESS: 'GET_PRESCRIPTORES_SUCCESS',
  GET_PRESCRIPTORES_REQUEST_FAILURE: 'GET_PRESCRIPTORES_FAILURE',

  GET_LISTADO_REQUEST: 'GET_LISTADO_REQUEST',
  GET_LISTADO_REQUEST_SUCCESS: 'GET_LISTADO_SUCCESS',
  GET_LISTADO_REQUEST_FAILURE: 'GET_LISTADO_FAILURE',

  GET_GRADUACIONES_REQUEST: 'GET_GRADUACIONES_REQUEST',
  GET_GRADUACIONES_REQUEST_SUCCESS: 'GET_GRADUACIONES_SUCCESS',
  GET_GRADUACIONES_REQUEST_FAILURE: 'GET_GRADUACIONES_FAILURE',

  GET_GRADUACION_REQUEST: 'GET_GRADUACION_REQUEST',
  GET_GRADUACION_REQUEST_SUCCESS: 'GET_GRADUACION_SUCCESS',
  GET_GRADUACION_REQUEST_FAILURE: 'GET_GRADUACION_FAILURE',
  
  GET_OLD_GRADUACION_REQUEST: 'GET_OLD_GRADUACION_REQUEST',
  
  GET_GRADUACION_EXTENDIDA_REQUEST: 'GET_GRADUACION_EXTENDIDA_REQUEST',
  GET_GRADUACION_EXTENDIDA_REQUEST_SUCCESS: 'GET_GRADUACION_EXTENDIDA_SUCCESS',
  GET_GRADUACION_EXTENDIDA_REQUEST_FAILURE: 'GET_GRADUACION_EXTENDIDA_FAILURE',

  SET_GRADUACION_REQUEST: 'SET_GRADUACION_REQUEST',
  SET_GRADUACION_REQUEST_SUCCESS: 'SET_GRADUACION_SUCCESS',
  SET_GRADUACION_REQUEST_FAILURE: 'SET_GRADUACION_FAILURE',
};
